module.exports = __webpack_public_path__ + "static/img/course_2.3cdbfb72.png";